export const taxTypes = (state) => state.taxTypes
//--PRENDE ELEMENTO GRAZIE ALL'ID
export const getTaxTypeById = (state) => (id) => {
  return state.taxTypes.find(taxType => taxType.id === id)
}
